<div class="container">
  <app-breadcrumb [url]="goback"></app-breadcrumb>

  <mat-form-field>
    <mat-label>Filtrar</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Agente" />
  </mat-form-field>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>
      <!-- ID Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
        <td mat-cell *matCellDef="let row">{{ row.id }}</td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tabela</th>
        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
      </ng-container>

      <!-- updated Column -->
      <ng-container matColumnDef="updated">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Última Atualização
        </th>
        <td mat-cell *matCellDef="let row">
          {{ row.updated | date: "short" }}
        </td>
      </ng-container>

      <!-- update Column -->
      <ng-container matColumnDef="update">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="update-table"
        >
          Atualizar
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          [style.color]="row.color"
          class="update-table"
        >
          <mat-icon
            class="update-table__icon"
            (click)="updateTable(row.endpoint)"
            >update</mat-icon
          >
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
  </div>
</div>
